// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../../../../node_module_clones/react-router';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

// Utils
import { getNotificationId } from '../../../../../../../common/notifications/notificationModelUtils';
import { getGroupNotificationsToDisplay, getGroupTimestamp, getGroupUnseen } from '../../groups/notificationGroupUtils';
import { getMilanoteApplicationModeSelector } from '../../../../../../platform/platformSelector';

// Components
import NotificationListEntry from '../NotificationListEntry';

// Types
import { MilanoteApplicationMode } from '../../../../../../../common/platform/platformTypes';

// Styles
import './BaseNotificationGroup.scss';

const BaseNotificationGroup = (props) => {
    const { group, text, figure, actions, className, url, previousLastCheckedNotifications, onClick } = props;

    const notifications = getGroupNotificationsToDisplay(group);
    const timestamp = getGroupTimestamp(group);
    const isNew = timestamp > previousLastCheckedNotifications;

    const appMode = useSelector(getMilanoteApplicationModeSelector);
    const isMobile = appMode === MilanoteApplicationMode.mobile;

    return (
        <li className={classNames('BaseNotificationGroup', className)}>
            <Link className="link" tabIndex={-1} onClick={onClick} to={url}>
                <div className="group-connector" />
                <div className="group-section">
                    <div className="group-figure">{figure}</div>
                    <div className="group-text">{text}</div>
                    {!isMobile && <div className="group-actions">{actions}</div>}
                    <div className={classNames('indicator', { new: isNew, unseen: getGroupUnseen(group) })} />
                </div>
                <ul className="notifications-list">
                    {notifications.map((notification) => (
                        <NotificationListEntry
                            {...props}
                            key={getNotificationId(notification)}
                            group={group}
                            notification={notification}
                        />
                    ))}
                </ul>
            </Link>
        </li>
    );
};

BaseNotificationGroup.propTypes = {
    group: PropTypes.object,
    className: PropTypes.string,
    figure: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    text: PropTypes.string,
    url: PropTypes.string,
    previousLastCheckedNotifications: PropTypes.number,
    dispatchMarkNotificationsAsSeen: PropTypes.func,
    onClick: PropTypes.func,
};

export default BaseNotificationGroup;
